module.exports = __webpack_public_path__ + "img/img_footer_big_qrcode.06f2ed2c.png";